{
  "v7.pilotage.calendrier.aucun_gel": "Aucun gel sur la période.",
  "v7.pilotage.calendrier.aucune_livraison": "Aucune livraison prévue sur la période.",
  "v7.pilotage.calendrier.chevauchements": "{{n}} livraisons tombent pendant un gel.",
  "v7.pilotage.calendrier.chevauchements_one": "{{n}} livraison tombe pendant un gel.",
  "v7.pilotage.calendrier.filtre_projets": "Projets affichés",
  "v7.pilotage.calendrier.gels": "Périodes de gel",
  "v7.pilotage.calendrier.lien_versions": "Versions du programme",
  "v7.pilotage.calendrier.livraisons": "Livraisons des projets",
  "v7.pilotage.calendrier.mois_courant": "Mois courant",
  "v7.pilotage.calendrier.mois_precedent": "Mois précédent",
  "v7.pilotage.calendrier.mois_suivant": "Mois suivant",
  "v7.pilotage.calendrier.pendant_un_gel": "pendant un gel",
  "v7.pilotage.calendrier.titre": "Calendrier des livraisons du programme",
  "v7.pilotage.calendrier.tous_les_projets": "Tous les projets visibles",
  "v7.pilotage.calendrier.voir": "Voir",
  "v7.pilotage.calendrier.voir_gel": "Voir le gel {{gel}}",
  "v7.pilotage.calendrier.voir_livraison": "Voir la livraison {{version}} de {{projet}}",
  "v7.pilotage.code.CONTEXTE_INCOMPLET": "Le contexte du programme est incomplet : rechargez la page.",
  "v7.pilotage.code.DROIT_NON_TENU": "Vous ne tenez pas le droit requis pour ce geste.",
  "v7.pilotage.code.GARDE_DROIT_ABSENTE": "Ce geste n’est pas encore ouvert par la passerelle.",
  "v7.pilotage.code.PROGRAMME_OBJECTIF_PARENT_EN_CYCLE": "Cet objectif parent descend de l’objectif du programme : le rattachement créerait un cycle.",
  "v7.pilotage.code.PROGRAM_OBJECTIVE_CONFLICT": "L’objectif a été modifié entre-temps : rechargez avant d’enregistrer.",
  "v7.pilotage.code.PROGRAM_PILOT_REQUIRED": "Il faut être pilote du programme pour ce geste.",
  "v7.pilotage.code.PROGRAM_RISK_OWNER_NOT_MEMBER": "Le porteur doit être membre du programme.",
  "v7.pilotage.code.SANS_SESSION": "Votre session a expiré : reconnectez-vous.",
  "v7.pilotage.code.VALIDATION_ERROR": "Un champ est absent ou hors domaine.",
  "v7.pilotage.etat.chargement": "Chargement : {{quoi}}…",
  "v7.pilotage.etat.en_cours": "Enregistrement en cours…",
  "v7.pilotage.etat.erreur": "{{quoi}} : la lecture n’a pas abouti.",
  "v7.pilotage.etat.geste_echoue": "L’opération n’a pas abouti. Réessayez.",
  "v7.pilotage.etat.introuvable": "{{quoi}} : introuvable dans ce programme.",
  "v7.pilotage.etat.reessayer": "Réessayer",
  "v7.pilotage.etat.refus": "{{quoi}} : accès refusé pour votre profil.",
  "v7.pilotage.etat_gel.a_venir": "À venir",
  "v7.pilotage.etat_gel.actif": "En cours",
  "v7.pilotage.etat_gel.annule": "Annulé",
  "v7.pilotage.etat_gel.termine": "Terminé",
  "v7.pilotage.etat_livraison.annule": "Annulée",
  "v7.pilotage.etat_livraison.en_retard": "En retard",
  "v7.pilotage.etat_livraison.prevu": "Prévue",
  "v7.pilotage.etat_livraison.prevu_en_gel": "Prévue pendant un gel",
  "v7.pilotage.etat_livraison.realise": "Réalisée",
  "v7.pilotage.etat_repere.atteint": "Atteint",
  "v7.pilotage.etat_repere.en_retard": "En retard",
  "v7.pilotage.etat_repere.non_date": "Non daté",
  "v7.pilotage.etat_repere.prevu": "Prévu",
  "v7.pilotage.gel.aucun_designe": "Aucun gel n’est désigné : ouvrez cette fiche depuis le calendrier.",
  "v7.pilotage.gel.avertissement": "Un gel avertit les projets du programme : il ne bloque aucun geste depuis cet écran.",
  "v7.pilotage.gel.etat": "État",
  "v7.pilotage.gel.fenetre": "Période",
  "v7.pilotage.gel.introuvable": "Ce gel n’existe pas ou ne vous est pas accessible.",
  "v7.pilotage.gel.libelle": "le gel",
  "v7.pilotage.gel.motif": "Motif",
  "v7.pilotage.gel.perimetre": "Périmètre",
  "v7.pilotage.gel.titre": "Période de gel agrégée du programme",
  "v7.pilotage.gel.tous_environnements": "Tous les environnements du projet",
  "v7.pilotage.gel.voir_dans_le_projet": "Voir le gel dans le projet",
  "v7.pilotage.impact.high": "forte",
  "v7.pilotage.impact.low": "faible",
  "v7.pilotage.impact.medium": "moyenne",
  "v7.pilotage.livraison.aucune_designee": "Aucune livraison n’est désignée : ouvrez cette fiche depuis le calendrier.",
  "v7.pilotage.livraison.etat": "État",
  "v7.pilotage.livraison.fenetre": "Fenêtre",
  "v7.pilotage.livraison.introuvable": "Cette livraison n’existe pas ou ne vous est pas accessible.",
  "v7.pilotage.livraison.libelle": "la livraison",
  "v7.pilotage.livraison.titre": "Livraison agrégée du programme",
  "v7.pilotage.livraison.version": "Version",
  "v7.pilotage.livraison.voir_dans_le_projet": "Voir la livraison dans le projet",
  "v7.pilotage.objectif.aucun": "Aucun objectif n’est encore fixé.",
  "v7.pilotage.objectif.aucune_etape": "Aucune",
  "v7.pilotage.objectif.date_cible": "Date cible",
  "v7.pilotage.objectif.date_passee": "La date cible ne peut pas être dans le passé.",
  "v7.pilotage.objectif.enregistre": "Objectif enregistré.",
  "v7.pilotage.objectif.enregistrer": "Enregistrer l’objectif",
  "v7.pilotage.objectif.etape_cible": "Étape cible",
  "v7.pilotage.objectif.libelle": "l’objectif et le registre",
  "v7.pilotage.objectif.modifie_par": "Dernière modification : {{nom}}",
  "v7.pilotage.objectif.objectif": "Objectif",
  "v7.pilotage.objectif.parent": "Objectif parent",
  "v7.pilotage.objectif.recharger": "Recharger",
  "v7.pilotage.objectif.titre": "Réglages du programme — objectif et registre",
  "v7.pilotage.objectif.titre_section": "Objectif du programme",
  "v7.pilotage.objectif_element.annuler": "Annuler",
  "v7.pilotage.objectif_element.aucun_designe": "Aucun élément de tête n’est désigné : ouvrez ce dialogue depuis le backlog du programme.",
  "v7.pilotage.objectif_element.echeance": "Échéance (facultative)",
  "v7.pilotage.objectif_element.echeance_passee": "L’échéance ne peut pas être dans le passé.",
  "v7.pilotage.objectif_element.enregistre": "Objectif de l’élément enregistré.",
  "v7.pilotage.objectif_element.enregistrer": "Enregistrer",
  "v7.pilotage.objectif_element.indicateur": "Indicateur (facultatif)",
  "v7.pilotage.objectif_element.introuvable": "Cet élément n’existe pas dans le programme ou ne vous est pas accessible.",
  "v7.pilotage.objectif_element.objectif": "Objectif",
  "v7.pilotage.objectif_element.objectif_requis": "L’objectif est requis.",
  "v7.pilotage.objectif_element.titre": "Définir l’objectif d’un élément de tête",
  "v7.pilotage.objectif_element.titre_de": "Définir l’objectif de l’élément {{initiative}}",
  "v7.pilotage.onglets.configuration": "Configuration",
  "v7.pilotage.onglets.cycle_de_vie": "Cycle de vie du programme",
  "v7.pilotage.onglets.identite": "Identité",
  "v7.pilotage.onglets.nom": "Réglages du programme",
  "v7.pilotage.onglets.objectif_registre": "Objectif et registre",
  "v7.pilotage.progression.aucun_enfant": "Aucun programme enfant ne se rattache à cet objectif.",
  "v7.pilotage.progression.non_visibles": "{{n}} programmes enfants ne vous sont pas visibles : comptés sans détail, exclus de la valeur.",
  "v7.pilotage.progression.non_visibles_one": "{{n}} programme enfant ne vous est pas visible : compté sans détail, exclu de la valeur.",
  "v7.pilotage.progression.partielle": "valeur partielle",
  "v7.pilotage.progression.sans_mesure": "Sans mesure : {{noms}}",
  "v7.pilotage.progression.sans_valeur": "Progression non mesurable",
  "v7.pilotage.progression.titre": "Progression agrégée",
  "v7.pilotage.progression.valeur": "Progression : {{valeur}} %",
  "v7.pilotage.projets_non_visibles": "{{n}} projets du programme ne vous sont pas visibles : ils sont comptés sans détail.",
  "v7.pilotage.projets_non_visibles_one": "{{n}} projet du programme ne vous est pas visible : il est compté sans détail.",
  "v7.pilotage.provenance": "Projet d’origine",
  "v7.pilotage.registre.ajoute": "Élément ajouté au registre.",
  "v7.pilotage.registre.ajouter": "Ajouter au registre",
  "v7.pilotage.registre.aucun_choisi": "Choisissez un élément du registre pour le modifier.",
  "v7.pilotage.registre.choisir": "Choisir {{titre}}",
  "v7.pilotage.registre.choisir_court": "Choisir",
  "v7.pilotage.registre.clore": "Clore l’élément",
  "v7.pilotage.registre.clore_question": "Clore cet élément du registre ?",
  "v7.pilotage.registre.clos": "clos",
  "v7.pilotage.registre.confirmer_cloture": "Confirmer la clôture",
  "v7.pilotage.registre.gravite": "Gravité",
  "v7.pilotage.registre.gravite_porteur": "gravité {{gravite}} · porteur {{porteur}}",
  "v7.pilotage.registre.impact_note": "Note d’impact (1 à 5)",
  "v7.pilotage.registre.impact_nouveau": "Impact du nouvel élément (1 à 5)",
  "v7.pilotage.registre.impact_residuel": "Impact résiduel (1 à 5)",
  "v7.pilotage.registre.modifie": "Élément du registre modifié.",
  "v7.pilotage.registre.modifier": "Modifier l’élément",
  "v7.pilotage.registre.non_classe": "Non classé",
  "v7.pilotage.registre.non_note": "Non noté",
  "v7.pilotage.registre.nouvel_element": "Nouvel élément du registre",
  "v7.pilotage.registre.ouvert": "ouvert",
  "v7.pilotage.registre.parade": "Parade",
  "v7.pilotage.registre.porteur": "Porteur",
  "v7.pilotage.registre.probabilite": "Probabilité (1 à 5)",
  "v7.pilotage.registre.probabilite_nouveau": "Probabilité du nouvel élément (1 à 5)",
  "v7.pilotage.registre.probabilite_residuelle": "Probabilité résiduelle (1 à 5)",
  "v7.pilotage.registre.renoncer": "Renoncer",
  "v7.pilotage.registre.roam": "Classement ROAM",
  "v7.pilotage.registre.rouvrir": "Rouvrir l’élément",
  "v7.pilotage.registre.sans_porteur": "sans porteur",
  "v7.pilotage.registre.titre": "Registre des risques",
  "v7.pilotage.registre.titre_requis": "L’intitulé du nouvel élément est requis.",
  "v7.pilotage.registre.vide": "Le registre est vide.",
  "v7.pilotage.repere.aucun_designe": "Aucun repère n’est désigné : ouvrez cette fiche depuis la feuille de route.",
  "v7.pilotage.repere.aucune_cadence": "Aucune cadence ne contribue à ce repère.",
  "v7.pilotage.repere.aucune_contribution": "Aucune contribution de projet.",
  "v7.pilotage.repere.aucune_version": "Aucune version ne contribue à ce repère.",
  "v7.pilotage.repere.cadences": "Cadences contributrices",
  "v7.pilotage.repere.contributions": "Contributions des projets",
  "v7.pilotage.repere.contributions_non_divulguees": "{{n}} projets contribuent sans vous être accessibles : leurs contributions ne sont pas divulguées.",
  "v7.pilotage.repere.contributions_non_divulguees_one": "{{n}} projet contribue sans vous être accessible : sa contribution n’est pas divulguée.",
  "v7.pilotage.repere.date_prevue": "Date prévue",
  "v7.pilotage.repere.date_reelle": "Date réelle",
  "v7.pilotage.repere.dates": "Dates du repère",
  "v7.pilotage.repere.etat": "État",
  "v7.pilotage.repere.intitule": "Intitulé",
  "v7.pilotage.repere.introuvable": "Ce repère n’existe pas ou ne vous est pas accessible.",
  "v7.pilotage.repere.libelle": "le repère",
  "v7.pilotage.repere.lien_versions": "Versions du programme",
  "v7.pilotage.repere.nature": "Nature (modèle)",
  "v7.pilotage.repere.non_atteint": "Pas encore atteint",
  "v7.pilotage.repere.non_date": "Non daté",
  "v7.pilotage.repere.pas_une_porte": "Ce repère n’est pas une porte du modèle : aucune condition de passage.",
  "v7.pilotage.repere.porte": "Porte du modèle",
  "v7.pilotage.repere.retour": "Retour à la feuille de route",
  "v7.pilotage.repere.titre": "Repère du programme",
  "v7.pilotage.repere.versions": "Versions contributrices",
  "v7.pilotage.repere.voir_element": "Voir l’élément du programme",
  "v7.pilotage.retour_calendrier": "Retour au calendrier",
  "v7.pilotage.roam.accepte": "Accepté",
  "v7.pilotage.roam.attenue": "Atténué",
  "v7.pilotage.roam.possede": "Possédé",
  "v7.pilotage.roam.resolu": "Résolu",
  "v7.pilotage.sans_programme": "Aucun programme n’est choisi : choisissez un programme dans la barre de contexte.",
  "v7.pilotage.scores.aucun": "Aucun élément ouvert à noter.",
  "v7.pilotage.scores.inherent": "probabilité {{p}} × impact {{i}}",
  "v7.pilotage.scores.resume": "Score inhérent {{inherent}} · résiduel {{residuel}}",
  "v7.pilotage.scores.titre": "Scores inhérents et résiduels",
  "v7.pilotage.vague_ulterieure": "« {{ecran}} » mène à un écran qui n’est pas encore réalisé.",
  "v7.pilotage.version.aucune_approbation_globale": "Aucune approbation globale n’est implicite : chaque projet garde ses propres portes et approbations.",
  "v7.pilotage.version.aucune_composante": "Aucune version composante visible.",
  "v7.pilotage.version.aucune_designee": "Aucune version n’est désignée : ouvrez cette fiche depuis les versions du programme.",
  "v7.pilotage.version.aucune_livraison": "aucune livraison prévue",
  "v7.pilotage.version.composantes": "Versions composantes des projets",
  "v7.pilotage.version.composition": "{{n}} projets composent cette version",
  "v7.pilotage.version.composition_one": "{{n}} projet compose cette version",
  "v7.pilotage.version.compteurs": "{{elements}} éléments, {{anomalies}} anomalies, {{revisions}} révisions",
  "v7.pilotage.version.introuvable": "Cette version n’existe pas ou ne vous est pas accessible.",
  "v7.pilotage.version.libelle": "la version",
  "v7.pilotage.version.preparation": "Préparation par environnement",
  "v7.pilotage.version.production": "production",
  "v7.pilotage.version.retour": "Retour aux versions",
  "v7.pilotage.version.titre": "Fiche de version du programme",
  "v7.pilotage.version.titre_de": "Version {{version}} du programme",
  "v7.pilotage.version.voir_dans_le_projet": "Voir la version dans le projet",
  "v7.pilotage.versions.aucun_gel": "Aucun gel",
  "v7.pilotage.versions.aucune": "Aucune version dans les projets visibles du programme.",
  "v7.pilotage.versions.aucune_fenetre": "Aucune fenêtre de mise en production",
  "v7.pilotage.versions.composee_de": "projets : {{projets}}",
  "v7.pilotage.versions.fenetre": "Mise en production le {{date}} ({{environnement}})",
  "v7.pilotage.versions.gel_du_au": "Gel du {{du}} au {{au}}",
  "v7.pilotage.versions.lire_projet": "lire dans le projet",
  "v7.pilotage.versions.liste": "Versions agrégées des projets",
  "v7.pilotage.versions.non_agregees": "Le modèle de ce programme ne regroupe pas les versions de ses projets : lisez-les dans chaque projet.",
  "v7.pilotage.versions.titre": "Versions du programme",
  "v7.pilotage.versions.voir_version": "Voir la version {{version}}"
}
